import axios from "axios";

export const TOKEN_KEY = "sate_admin_token";
export const MEMBER_TOKEN_KEY = "sate_member_token";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const memberApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

memberApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(MEMBER_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail?.msg || String(detail);
}

export const DEFAULT_SETTINGS = {
  hero_line1: "Launch Your Own",
  hero_line2: "Traffic Exchange",
  hero_line3: "Business Today.",
  hero_sub:
    "Complete traffic exchange software. Start your own traffic exchange website and build a profitable online business — we install it, host it and hand you the keys.",
  price: "99",
  price_label: "One time payment",
  price_note: "No monthly fees. Ever.",
  buy_url: "",
  buy_text: "Buy Now",
  demo_text: "View Live Demo",
  demo_url: "https://trafficexchange.app/",
  hero_cta_text: "See the $99 offer",
  hero_cta_url: "#pricing",
  hero_secondary_text: "See what's inside",
  hero_secondary_url: "#features",
  final_cta_text: "View the $99 offer",
  final_cta_url: "#pricing",
  phone: "",
  email: "",
  announcement: "Free installation, free domain & lifetime hosting included",
  testimonials: [
    { name: "Mark D.", role: "Owner, a traffic exchange site", image: "/img/cust1.jpg", rating: 5, quote: "I had my own traffic exchange live within days. Installation, domain and hosting were all taken care of — I just added my branding and started inviting members." },
    { name: "Sarah L.", role: "Online marketer", image: "/img/cust2.jpg", rating: 5, quote: "The admin panel makes it easy to manage members, sites and credit packages. A one-time $99 with no monthly fees was a no-brainer for me." },
    { name: "Richard P.", role: "Home business owner", image: "/img/cust3.jpg", rating: 5, quote: "I'm not a tech person, so the 24/7 phone support was a big deal. Real people answered every question I had." },
  ],
};

export const linkProps = (url, fallback) => {
  const href = url || fallback;
  return /^https?:\/\//i.test(href) ? { href, target: "_blank", rel: "noopener noreferrer" } : { href };
};

export async function fetchSettings() {
  try {
    const { data } = await api.get("/settings");
    return { ...DEFAULT_SETTINGS, ...(data || {}) };
  } catch {
    return DEFAULT_SETTINGS;
  }
}
